import { Record as record } from 'immutable';
import _ from 'lodash';

import { construct, fields } from '../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../helpers/Records';

const schema = {
    id: [fields.number],
    orderId: [fields.number],
    ticketId: [fields.number],
    created: [fields.datetime],
    issuedDate: [fields.datetime],
    issuedTicketNumber: [fields.number],
};
const defaults = getDefaults(schema);

export default class OrderTicket extends record(defaults) {
    static fromJSON(json) {
        return construct(OrderTicket, _.defaults(json, defaults), getResolvers(schema));
    }
}



// WEBPACK FOOTER //
// ./src/records/order/TicketIssued.js